import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";
import DiscountCellContent from "../components/DiscountCellContent";

function discount({ width, onResize }: Column.Options) {
	return base(
		ColumnId.Discount,
		(item) => <DiscountCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default discount;
